module.exports = __webpack_public_path__ + "img/ma.7ccf0a17.svg";